export default __webpack_public_path__ + "static/media/03.3611af5d.jpg";